import React from 'react';
import Select from 'react-select';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

const SkuFilters = ({ filters, onFilterChange, onSearch, onReset, skuTypes, listingTypes, statusOptions}) => {
    const handleInputChange = (field, value) => {
        onFilterChange({
            ...filters,
            [field]: value,
        });
    };

    const handleTextChange = (e) => {
        onFilterChange({
            ...filters,
            search: e.target.value,
        });
    };

    return (
        <Form onSubmit={(e) => e.preventDefault()}>
            <div className='sku-input m-sm'>
                <Form.Label>Search By</Form.Label>
                <Form.Control
                    placeholder="Search by SKU Name. Id"
                    value={filters.search || ''}
                    onChange={handleTextChange}
                />
            </div>

            {/* <div className='m-sm sku-input'>
                <Form.Label>SKU Name</Form.Label>
                <Select
                    value={filters.skuName}
                    onChange={(option) => handleInputChange('skuName', option)}
                    options={skuNameOptions}
                />
            </div> */}

            <div className='m-sm city-input'>
                <Form.Label>SKU Type</Form.Label>
                <Select
                    value={filters.skuType}
                    onChange={(option) => handleInputChange('skuType', option)}
                    options={skuTypes}
                />
            </div>

            <div className='m-sm city-input'>
                <Form.Label>Listing Type</Form.Label>
                <Select
                    value={filters.listingType}
                    onChange={(option) => handleInputChange('listingType', option)}
                    options={listingTypes}
                />
            </div>

            <div className='m-sm city-input'>
                <Form.Label>Status</Form.Label>
                <Select
                    value={filters.is_enable}
                    onChange={(option) => handleInputChange('is_enable', option)}
                    options={statusOptions}
                />
            </div>

            <Button
                variant="solid bg-orange w-auto m-xs-l"
                onClick={onSearch}
                type="button"
            >
                Search
            </Button>
            <Button
                variant="default m-sm-l"
                onClick={onReset}
                type="button"
            >
                Reset
            </Button>
        </Form>
    );
};

export default SkuFilters;
